import React from 'react';
import { useQuery } from '@apollo/client';

import { Loading } from 'app/src/elements/DataState';
import { useParams } from 'app/src/utils/routing';

import NewTag from './new';
import { TAG } from './queries';

const Resubmit = () => {
  const { id } = useParams();
  const { data } = useQuery(TAG, { variables: { id } });

  if (!data) { return <Loading />; }

  const tag = {
    ...data.tag,
  };

  tag.dealerId = tag.dealer.id;

  if (tag.keepTag) {
    tag.tagType = 'keep';
  } else if ('ADR' === tag.vendor) {
    tag.tagType = 'adr';
  } else {
    tag.tagType = 'other';
  }

  console.log(tag);

  return (
    <NewTag resubmitValues={tag} />
  );
};

export default Resubmit;
